import { useState, useEffect } from 'react';
import { detectSimpleSource, SimpleSource } from '../lib/sourceDetection';

export function useSourceDetection() {
  const [source, setSource] = useState<SimpleSource>("direct");

  useEffect(() => {
    const detectSource = () => {
      try {
        const currentSearch = window.location.search;
        const currentReferrer = document.referrer;
        const detectedSource = detectSimpleSource(currentSearch, currentReferrer);
        setSource(detectedSource);
      } catch (error) {
        setSource("direct");
      }
    };

    detectSource();

    const handleFocus = () => {
      detectSource();
    };

    window.addEventListener('focus', handleFocus);
    
    return () => {
      window.removeEventListener('focus', handleFocus);
    };
  }, []);

  return { source };
}